import React from "react";
import { useState, useEffect } from "react";
import "./OutletFormProgressCard.css";
import _ from "lodash";

import { ReactComponent as OutletDetailsIcon } from "../../assets/image/svg/outletDetailsOutletForm.svg";
import { ReactComponent as FinanceIcon } from "../../assets/image/svg/financeDetailsOutletForm.svg";
import { ReactComponent as BillShipIcon } from "../../assets/image/svg/shippingBillingOutletForm.svg";
import { ReactComponent as AdditionalIcon } from "../../assets/image/svg/additionalDetailsOutletForm.svg";

interface OrderTrackingProps {
  trackingStagesList: any[];
  stages: Record<string, number>;
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  isPage1Complete: () => void,
  isPage2Complete: () => void,
  isPage3Complete: () => void,
  isPage4Complete: () => void,
}

const OutletFormProgressCard: React.FC<OrderTrackingProps> = ({
  setCurrentPage,
  isPage1Complete,
  isPage2Complete,
  isPage3Complete,
  isPage4Complete,
  currentPage,
  trackingStagesList,
  stages,
}) => {
  const [stagesConfig, setStagesConfig] = useState<any>({});

  useEffect(() => {
    const updatedStagesColors = trackingStagesList?.reduce(
      (acc: any, curr: any, index: number) => {
        const { id, dmsLabelColor, dmsColor, dmsLabel } = curr ?? {};

        // ✅ Now the stepper is based on `currentPage` instead of `status`
        const fillWithColor = index <= currentPage;

        if (!acc?.[id]) {
          acc[id] = { styles: {}, label: {} };
        }

        acc[id].styles = {
          color: fillWithColor ? dmsLabelColor ?? "#7c7c7c" : "#7c7c7c",
          borderColor: fillWithColor ? dmsLabelColor ?? "#B9B9B9" : "#B9B9B9",
          backgroundColor: fillWithColor ? dmsColor ?? "#fff" : "#fff",
        };

        acc[id].addInfo = { label: dmsLabel };

        return acc;
      },
      {}
    );

    setStagesConfig(updatedStagesColors);
  }, [trackingStagesList, currentPage]);
  const getPageNumber = (stage: string) => {
    switch (stage) {
      case "OUTLET_DETAILS":
        return 1;
      case "FINANCIAL_DETAILS":
        return 2;
      case "SHIPPING_AND_BILLING_DETAILS":
        return 3;
      case "ADDITIONAL_DETAILS":
        return 4;
      default:
        return 1;
    }
  }
  const getIcon = (stage: string) => {
    switch (stage) {
      case "OUTLET_DETAILS":
        return <OutletDetailsIcon />;
      case "FINANCIAL_DETAILS":
        return <FinanceIcon />;
      case "SHIPPING_AND_BILLING_DETAILS":
        return <BillShipIcon />;
      case "ADDITIONAL_DETAILS":
        return <AdditionalIcon />;
      default:
        return <OutletDetailsIcon />;
    }
  };

  const getStageStyles = (stage: string) => {
    const { color, borderColor, backgroundColor } =
      stagesConfig?.[stage]?.styles ?? {};

    return {
      color,
      borderColor,
      backgroundColor,
    };
  };

  const getStageLabel = (stage: string) => {
    const { label } = stagesConfig?.[stage]?.addInfo ?? {};
    return label;
  };

  return (
    <div
      className="OrderTrackingContainerOutlet"
      style={{ marginLeft: "120px" }}
    >
      {Object.keys(stages)?.map((stage: string, idx: number, arr: any) => {
        return (
          <div
            style={{ display: "flex", flexDirection: "column", height: "50px" }}
          >
            <div key={stage} className="OrderTracking_stageContainerOutlet">
              <div className="OrderTracking_stageNameContainerOutlet">
                <div onClick={() => {
                  const targetPage = getPageNumber(stage);
                  let canNavigate = true;

                  for (let i = 1; i < targetPage; i++) {
                    const isComplete = 
                      (i === 1 && isPage1Complete()) ||
                      (i === 2 && isPage2Complete()) ||
                      (i === 3 && isPage3Complete()) ||
                      (i === 4 && isPage4Complete());

                    if (!isComplete) {
                      canNavigate = false;
                      break;
                    }
                  }

                  if (canNavigate) {
                    setCurrentPage(targetPage);
                  }
                }} 
                
                style={{ ...getStageStyles(stage), cursor: 'pointer' }} >{getIcon(stage)}</div>
                <span style={{ color: getStageStyles(stage)?.color }}></span>
              </div>
              {idx < arr?.length - 1 && (
                <span className="OrderTracking_stageSeperatorOutlet">
                  - - - - - - - - - - - - - - -
                </span>
              )}
            </div>
            <span
              onClick={() => {
                if (
                  (currentPage === 1 && isPage1Complete()) ||
                  (currentPage === 2 && isPage2Complete()) ||
                  (currentPage === 3 && isPage3Complete()) ||
                  (currentPage === 4 && isPage4Complete()) ||
                  currentPage >= getPageNumber(stage)
                ) {
                  setCurrentPage(getPageNumber(stage));
                }
              }} 
              style={{
                width: "120px",
                color: getStageStyles(stage)?.color,
                fontSize: "12.5px",
                cursor: "pointer",
              }}
            >
              {getStageLabel(stage)}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default OutletFormProgressCard;
